import { SVGProps } from 'react';
import { BaseContainerComponentPropsType } from '../../util/types';
import AvatarArtwork, { type RenderShadowFn } from '../AvatarArtwork';
import { avatarDefaultBackgroundColors } from '../../config/avatarColors';

const renderShadow: RenderShadowFn = (props) => (
  <polygon
    {...props}
    points="47.92 25.07 47.92 47.83 29.37 47.9 20.9 33.36 30.82 10.32 47.92 25.07"
  />
);

export let AvatarArtworkEvelynWang = (
  props: {
    backgroundColor?: string;
  } & BaseContainerComponentPropsType &
    SVGProps<SVGSVGElement>,
) => (
  <AvatarArtwork
    {...props}
    defaultBackgroundColor={avatarDefaultBackgroundColors.evelynWang}
    renderShadow={renderShadow}
  >
    <g
      style={{
        transform: 'scale(1.1) translate(-2px,-2px)',
      }}
    >
      <path
        d="m27.03,9.37c.78.16,1.57.33,2.24.67.77.39,1.34.97,1.84,1.57,2.33,2.82,2.65,6.89,2.12,10.13-.17,1.03.37,1.84.45,2.46.15,1.2-.6,2.32-.59,3.55,0,2.33,1.13,3.83,2,4.98l-1.47-.82c-.46,3.09-.82,5.73,1.29,8.45-1.65-1.28-1.85-2.1-3.14-3.6-.07,1.71.53,3.44,1.69,4.93-1.72-.29-3.22-.6-3.79-1.89-.65.28-.82.25-1.46.52,1.06-.72.07-2.63-.01-3.74s.67-2.28.28-3.04c-.17-.35-.86-.96-1-1.21-.17-.32-.36-1.01-.58-1.31l.14-21.66Z"
        style={{
          fill: '#262321',
          stroke: '#473d39',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.53,
        }}
      />
      <path
        d="m20.5,9.31c-.77.17-1.56.36-2.23.72-.76.41-1.32,1.01-1.8,1.62-2.27,2.88-2.71,6.33-2.61,9.58.03,1.04.53,2.05.32,3.09-.12.59-.41,1.21-.19,1.77.13.35.25.89.44,1.22.37.63,0,3.15-.63,4.81.48-.28.26-.14.75-.42.53,3.08.3,5.56-1.75,8.33,1.92-1,1.39-.5,2.65-2.04.1,1.71.62,2.86-.51,4.38.45-.09,2.41-1.34,2.84-1.4.79-.1,1.59,1.08,1.59,1.08,0,0-.73-3.35.17-5.02.53-.98-.07-2.07-.38-3.49-.06-.26.42-.52.55-.77.16-.32,1.43-.53,1.65-.83l-.8-22.53"
        style={{
          fill: '#262321',
          stroke: '#473d39',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.53,
        }}
      />
      <path
        d="m32.44,15.19s-.85,9.21-1.14,12.27-5.33,6.95-5.33,6.95c-1.83,1.25-3.24,1.25-5.07,0,0,0-5.09-4.12-5.33-6.95-.26-3.07-1.14-12.28-1.14-12.28-.08-1.55.21-3.01,1.49-3.79l4.53-2.76c1.83-1.11,4.08-1.11,5.91,0l4.58,2.77c1.28.78,1.57,2.24,1.5,3.79Z"
        style={{
          fill: '#eca992',
        }}
      />
      <g>
        <circle
          cx="24.03"
          cy="18.5"
          r="1.85"
          style={{
            fill: '#efd5c7',
            stroke: '#262321',
            strokeMiterlimit: 10,
            strokeWidth: 0.34,
          }}
        />
        <circle
          cx="23.71"
          cy="19.08"
          r=".84"
          style={{
            fill: '#262321',
          }}
        />
      </g>
      <path
        d="m28.84,12.06c-1.6,4.55-7.01,6.72-12.1,7.06,4.43-1.28,5.25-3.55,6.36-5.23-1.39,1.05-5.72,5.03-9.13,5.15-.55-2.69.89-6.45,2.51-8.42,4.42-5.37,10.41-4.39,12.91-.96,3.72.66,4.34,7.46,2.97,9.8-1.81,0-4.08-3.9-3.52-7.4Z"
        style={{
          fill: '#262321',
          stroke: '#473d39',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.49,
        }}
      />
      <g>
        <rect
          x="13.14"
          y="20.02"
          width="1.05"
          height="3.9"
          rx=".52"
          ry=".52"
          transform="translate(-2.05 1.42) rotate(-5.53)"
          style={{
            fill: '#229489',
          }}
        />
        <rect
          x="13.66"
          y="18.75"
          width="1.43"
          height="6.32"
          rx=".72"
          ry=".72"
          transform="translate(-2.04 1.49) rotate(-5.53)"
          style={{
            fill: '#229489',
          }}
        />
        <path
          d="m14.31,21.13s-.13-1.36.33,3.39c.05.56.41,1.58.82,1.92"
          style={{
            fill: 'none',
            stroke: '#7db898',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: 0.64,
          }}
        />
      </g>
      <g>
        <rect
          x="32.47"
          y="19.99"
          width="1.08"
          height="3.9"
          rx=".54"
          ry=".54"
          transform="translate(64.29 46.29) rotate(-175.73)"
          style={{
            fill: '#229489',
          }}
        />
        <rect
          x="31.54"
          y="18.73"
          width="1.47"
          height="6.32"
          rx=".74"
          ry=".74"
          transform="translate(62.83 46.12) rotate(-175.73)"
          style={{
            fill: '#229489',
          }}
        />
        <path
          d="m32.33,21.11s.1-1.36-.25,3.4c-.04.56-.38,1.59-.8,1.94"
          style={{
            fill: 'none',
            stroke: '#7db898',
            strokeLinecap: 'round',
            strokeLinejoin: 'round',
            strokeWidth: 0.65,
          }}
        />
      </g>
      <path
        d="m17.43,20.12c1.11-.04,2.26-.09,3.31.22.37.11.74.26,1,.51s.4.61.29.93c-1.35-1.18-3.08-1.06-4.2-1.29-.14-.03-.4-.37-.4-.37Z"
        style={{
          fill: '#262321',
          stroke: '#262321',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.16,
        }}
      />
      <path
        d="m30.2,20.12c-1.18-.04-2.4-.09-3.52.22-.39.11-.78.26-1.06.51s-.43.61-.3.93c1.43-1.18,3.28-1.06,4.46-1.29.15-.03.43-.37.43-.37Z"
        style={{
          fill: '#262321',
          stroke: '#262321',
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeWidth: 0.17,
        }}
      />
      <path
        d="m21.3,28.05l-1.59,2.22c.84-.46,1.46-1.31,1.63-2.26"
        style={{
          fill: '#e08f79',
        }}
      />
      <path
        d="m25.92,28.01l1.59,2.22c-.84-.46-1.46-1.31-1.63-2.26"
        style={{
          fill: '#e08f79',
        }}
      />
      <path
        d="m26.21,30.74s-.66.82-1.22,1.03c-.84.31-2.02.24-2.83-.07-.49-.19-1.26-.94-1.26-.94l5.31-.02Z"
        style={{
          fill: '#d16d69',
        }}
      />
      <path
        d="m25.39,30.57c.49.06.82.14.82.14,0,0-1.68.64-2.55.64s-2.76-.59-2.76-.59c0,0,.51-.11,1.11-.2.5-.07,2.83-.07,3.38,0Z"
        style={{
          fill: '#c35b54',
        }}
      />
    </g>
  </AvatarArtwork>
);
